import Vue from 'vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'

Vue.component('VueSlickCarousel', VueSlickCarousel)
